import '../themeDefaults';

export default ({ formComponents, palette }) => ({
  root: {
    display: ({ inline }) => (!inline ? 'block' : 'inline-block'),
    opacity: ({ disabled }) => disabled && 0.5,
    marginBottom: 15,

    '& > p': {
      position: 'relative',
      top: () => (formComponents.checkboxRadioSvgDisplay === 'none' ? 0 : -2),
      color: ({ dark }) => (dark ? palette.text.light : palette.text.dark)
    },

    '& input[type="checkbox"]': {
      ...formComponents.hiddenCheckbox,
      '&:focus': {
        outline: ({ dark }) => (dark
          ? `${formComponents.checkbox.darkFocusColor} solid 1px`
          : `${formComponents.checkbox.focusColor} solid 1px`
        )
      }
    },
    '& input[type="checkbox"] + div': {
      display: formComponents.checkboxRadioSvgDisplay
    },

    '& input[type="checkbox"] + div svg': {
      background: ({ dark }) => (dark
        ? formComponents.checkbox.dark.checkBackground
        : formComponents.checkbox.checkBackground),
      fill: ({ dark }) => (dark
        ? formComponents.checkbox.dark.fill
        : formComponents.checkbox.fill),
      height: formComponents.checkboxLabel.fontSize,
      width: formComponents.checkboxLabel.fontSize
    },
    '& input[type="checkbox"]:checked + div svg': {
      background: ({ dark }) => (dark
        ? formComponents.checkbox.dark.selectedBackground
        : formComponents.checkbox.selectedBackground),
      fill: ({ dark }) => (dark
        ? formComponents.checkbox.dark.selectedFill
        : formComponents.checkbox.selectedFill)
    },
    '& input[type="checkbox"]:indeterminate + div svg': {
      background: ({ dark }) => (dark
        ? formComponents.checkbox.dark.selectedBackground
        : formComponents.checkbox.selectedBackground),
      fill: ({ dark }) => (dark
        ? formComponents.checkbox.dark.selectedFill
        : formComponents.checkbox.selectedFill)
    },
    '& input[type="checkbox"]:focus + div': {
      outline: ({ dark }) => (dark
        ? `${formComponents.checkbox.darkFocusColor} solid 1px`
        : `${formComponents.checkbox.focusColor} solid 1px`
      ),
      boxShadow: `0 0px 8px ${formComponents.checkbox.shadowColor}`
    },
    '& input[type="checkbox"]:disabled': {
      ...formComponents.disabled
    },
    '& input[type="checkbox"]:disabled + div': {
      background: formComponents.checkbox.disabledColor
    },
    /** Radio styles */
    '& input[type="radio"]': {
      ...formComponents.hiddenCheckbox,
      '&:focus': {
        outline: ({ dark }) => (dark
          ? `${formComponents.checkbox.darkFocusColor} solid 1px`
          : `${formComponents.checkbox.focusColor} solid 1px`
        )
      }
    },
    '& input[type="radio"] + div': {
      display: formComponents.checkboxRadioSvgDisplay
    },
    '& input[type="radio"] + div svg': {
      background: ({ dark }) => (dark
        ? formComponents.radio.dark.radioBackground
        : formComponents.radio.radioBackground),
      fill: ({ dark }) => (dark
        ? formComponents.radio.dark.fill
        : formComponents.radio.fill),
      height: formComponents.checkboxLabel.fontSize,
      width: formComponents.checkboxLabel.fontSize
    },
    '& input[type="radio"]:focus + div': {
      outline: ({ dark }) => (dark
        ? `${formComponents.checkbox.darkFocusColor} solid 1px`
        : `${formComponents.checkbox.focusColor} solid 1px`
      ),
      boxShadow: `0 0px 8px ${formComponents.checkbox.shadowColor}`
    },
    '& input[type="radio"]:disabled ~ span': {
      color: formComponents.checkbox.disabledColor
    },
    '& input[type="radio"]:disabled + div': {
      background: palette.grey.G400
    }
  },
  helpWrapper: {
    display: 'flex',
    flexWrap: 'nowrap',
    justifyContent: 'space-between'
  }
});
